import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ROWS = [
  { k: "Join us", v: "Build machines that go to sea.", to: "/careers", id: "join" },
  { k: "Partner with us", v: "Solve part of the problem with us.", to: "/partners", id: "partner" },
  { k: "Stay updated", v: "Read and subscribe to the Logbook.", to: "/logbook", id: "follow" },
];

export const ActionRows = () => (
  <section className="border-t border-white/[0.06]" data-testid="action-rows" data-analytics-section="actions">
    {ROWS.map((r) => (
      <Link key={r.id} to={r.to} className="group relative block overflow-hidden border-b border-white/[0.06]" data-testid={`action-row-${r.id}`}>
        <span className="absolute inset-0 origin-bottom scale-y-0 bg-fg transition-transform duration-700 ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-y-100" />
        <div className="shell relative flex items-center justify-between gap-6 py-9 sm:py-12">
          <div className="flex items-baseline gap-5 sm:gap-8">
            <span className="text-[2.6rem] font-[540] leading-none tracking-[-0.045em] text-fg transition-colors duration-500 group-hover:text-ink sm:text-7xl lg:text-8xl">{r.k}</span>
          </div>
          <div className="flex items-center gap-6">
            <span className="hidden max-w-[16rem] text-right text-[15px] text-fg-2 transition-colors duration-500 group-hover:text-ink/75 md:block">{r.v}</span>
            <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-white/20 text-fg transition-[transform,background-color,color,border-color] duration-500 group-hover:rotate-45 group-hover:border-ink group-hover:bg-ink group-hover:text-fg sm:h-16 sm:w-16">
              <ArrowUpRight className="h-5 w-5" />
            </span>
          </div>
        </div>
      </Link>
    ))}
  </section>
);
